"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../constants");

// 验证install方法的部分字段
var _default = function _default(_ref) {
  var serviceId = _ref.serviceId;
  var errMsg = '';

  switch (true) {
    case !_constants.SERVICE_ID_REG.test(serviceId):
      errMsg = 'serviceId is required or invalid';
      break;

    default:
      break;
  }

  if (errMsg) throw new Error(errMsg);
};

exports.default = _default;